import { useQuery } from '@tanstack/react-query'
import { outsiderApiClient } from '@/app/services/outsiderApiClient'
import type { Blog, BlogCategory } from '@/app/types/blog'

export const useBlog = (slug: string) => {
  const context = useQuery({
    queryKey: [`/blog/${slug}`, slug],
    queryFn: () => outsiderApiClient.get<StatusResponse<Blog[]>>(`/api/blog/${slug}`),
  })

  return {
    ...context,
    data: context?.data?.data?.data[0] || ({} as Blog),
  }
}

export const useBlogs = (params?: any) => {
  const context = useQuery({
    queryKey: ['/blogs', params],
    queryFn: () => outsiderApiClient.get<PaginatedResponse<Blog>>('/api/blogs', { params }),
  })

  return {
    ...context,
    data: context?.data?.data?.data || [],
    meta: context?.data?.data?.meta || ({} as PaginationMeta),
  }
}

export const useBlogCategories = () => {
  const context = useQuery({
    queryKey: ['/blog/category'],
    queryFn: () => outsiderApiClient.get<PaginatedResponse<BlogCategory>>('/api/blog/category', { params: { no_pagination: 1 } }),
  })

  return {
    ...context,
    data: context?.data?.data?.data || [],
  }
}
